<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">{{$store.state.themeTitle}}室分级管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实训项目">
          <el-input v-model="formInline.train_name" clearable placeholder="请输入实训项目"></el-input>
        </el-form-item> -->

        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建分级</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="name" label="分级名称" width="160">
      </custom-table-column>
      <custom-table-column prop="level" label="等级" width="160">
      </custom-table-column>
      <custom-table-column prop="danger_source" label="危险源" min-width="220">
      </custom-table-column>
      <custom-table-column prop="protections_points" label="防护要点" width="160">
      </custom-table-column>
      <custom-table-column prop="special_equipment" label="特种设备" width="150">
      </custom-table-column>
      <custom-table-column prop="emergency_preparedness" label="应急预案" width="160">
      </custom-table-column>
      <custom-table-column prop="safety_facilities" label="安全设施" width="150">
      </custom-table-column>
      <custom-table-column label="警示图标" min-width="240">
        <template slot-scope="scope" v-if="scope.row.warning_icons">
          <el-image v-for="(item,index) in scope.row.warning_icons.split(',')" :key="index" :src="item" :preview-src-list="scope.row.warning_icons.split(',')" style="width: 60px; height: 60px;margin-right: 4px;">
          </el-image>
        </template>
      </custom-table-column>
      <!-- <custom-table-column prop="desc" label="备注" min-width="200">
      </custom-table-column> -->
      <custom-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <!-- <el-button @click="handleAddItem(scope.row.id)" type="text" size="small">添加条目</el-button> -->
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="分级名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入分级名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="等级" prop="level">
          <el-input v-model.number="ruleForm.level" placeholder="请输入等级数字" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="危险源" prop="danger_source">
          <el-input type="textarea" placeholder="请输入危险源" :rows="4" v-model="ruleForm.danger_source" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="应急预案" prop="emergency_preparedness">
          <el-input type="textarea" placeholder="请输入应急预案" :rows="4" v-model="ruleForm.emergency_preparedness" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="特种设备" prop="special_equipment">
          <!-- <div @click="handleEquipFocus">
          <el-input type="textarea" placeholder="请输入特种设备" readonly :rows="4" v-model="ruleForm.special_equipment" style="width:552px;"></el-input>
          </div> -->
          <el-tag :key="tag" v-for="(tag,index) in eqs" closable :disable-transitions="false" @close="handleClose(tag,index)">
            {{tag}}
          </el-tag>
          <el-input class="input-new-tag" ref="saveTagInput" v-if="inputVisible" @blur="handleInputConfirm" v-model="inputValue" placeholder="">
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加设备</el-button>
        </el-form-item>
        <el-form-item label="防护要点" prop="protections_points">
          <el-input type="textarea" placeholder="请输入防护要点" :rows="4" v-model="ruleForm.protections_points" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="安全设施" prop="safety_facilities">
          <!-- <el-input type="textarea" placeholder="请输入安全设施" :rows="4" v-model="ruleForm.safety_facilities" style="width:552px;"></el-input> -->
          <el-tag :key="tag" v-for="(tag,index) in safes" closable :disable-transitions="false" @close="handleClose1(tag,index)">
            {{tag}}
          </el-tag>
          <el-input class="input-new-tag" ref="saveTagInput1" v-if="inputVisible1" @blur="handleInputConfirm1" v-model="inputValue1" placeholder="">
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput1">+ 添加设施</el-button>
        </el-form-item>
        <el-form-item label="隐患图片" prop="file" style="width:100%">
            <Uploadd ref="uploadd" :action="action" :params="params" @setFileList="setUpFileList" @delFile="delUpFile" :btnTitle="btnTitle" :uploadType="uploadType"></Uploadd>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinUpload],
  data() {
    return {
      classRooms: [],
      institutes: [
        { isid: '1', ismc: '机电学院' },
        { isid: '2', ismc: '土木学院' },
      ],
      props: {
        label: 'name',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        structure_1: '',
        major: '',
        training_room: '',
        train_name: '',
        teacher: '',
      },

      formInline1: {},
      levell: [1, 2],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        name: '',
        level: '',
        danger_source: '',
        emergency_preparedness: '',
        special_equipment: '',
        protections_points: '',
        warning_icons: '',
        safety_facilities: '',
      },
      rules: {
        name: [{ required: true, message: '请输入分级名称', trigger: 'blur' }],
        level: [{ required: true, message: '请输入等级', trigger: 'blur' },{ type: 'number', message: '必须为数字值' },],
      },
      uploadType: 'image',
      btnTitle: '点击上传警示图标',
      eqs: [],
      inputValue: '',
      inputVisible: false,
      safes: [],
      inputValue1: '',
      inputVisible1: false,
      fileFieldName: 'warning_icons',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.$store.dispatch('getStandards');
  },
  watch: {
    eqs: {
      handler: function (val) {
        this.ruleForm.special_equipment = val.join(',');
      },
      deep: false,
    },
    safes: {
      handler: function (val) {
        this.ruleForm.safety_facilities = val.join(',');
      },
      deep: false,
    },
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },

    handleEdit(row, filterArr = ['school_id', 'updated_at', 'created_at']) {
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.eqs = row.special_equipment ? row.special_equipment.split(',') : [];
      this.safes = row.safety_facilities ? row.safety_facilities.split(',') : [];
      this.$nextTick(() => {
        if (row.warning_icons) {
          this.$refs.uploadd.setRefFileList(row.warning_icons);
        }
      });
      this.centerDialogVisible = true;
    },

    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training/safe/level/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/training/safe/level/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      if (this.selectName) {
        this.selectName = '';
      }
      this.eqs = [];
      this.safes = [];
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.uploadd.setRefFileList('');
      });
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/training/safe/level/update`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.tableData1 = [];
      console.log(this.ruleForm);
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training/safe/level/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleClose(tag, index) {
      this.eqs.splice(index, 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
        // this.$refs.saveTagInput.$children[0].$refs.input.focus();
      });
    },
    handleInputConfirm() {
      if (this.inputValue) {
        this.eqs.push(this.inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    handleClose1(tag, index) {
      this.safes.splice(index, 1);
    },

    showInput1() {
      this.inputVisible1 = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput1.$refs.input.focus();
        // this.$refs.saveTagInput.$children[0].$refs.input.focus();
      });
    },
    handleInputConfirm1() {
      if (this.inputValue1) {
        this.safes.push(this.inputValue1);
      }
      this.inputVisible1 = false;
      this.inputValue1 = '';
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
    box-shadow: 0 0 1px 1px #ccc;
    padding: 0 8px;
  }
}
</style>
